var SM = 432;
var MD = 660;
var L = 888;
var XL = 1116;
var XXL = 1280;
var SIZES = {
  SM: SM,
  MD: MD,
  L: L,
  XL: XL,
  XXL: XXL
};
export default SIZES;